import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ChangePasswordForm from "@/components/ChangePasswordForm";
import MfaSettings from "@/components/MfaSettings";
import { Ambulance, ArrowLeft } from "lucide-react";

// Mobile-first account page for drivers (the driver portal does not use the agency Layout).
export default function DriverAccount() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const mfaRequired = new URLSearchParams(location.search).get("mfa") === "required";

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-[#0A192F] text-white">
        <div className="max-w-lg mx-auto px-5 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-md bg-[#005E82] flex items-center justify-center"><Ambulance size={18} /></div>
            <div>
              <div className="font-display font-semibold text-sm">Your account</div>
              <div className="text-[11px] text-slate-400 truncate max-w-[180px]">{user?.email}</div>
            </div>
          </div>
          <button onClick={() => navigate("/driver")} className="text-slate-300 text-xs flex items-center gap-1.5 hover:text-white" data-testid="driver-account-back">
            <ArrowLeft size={14} /> Back to rides
          </button>
        </div>
      </header>

      <div className="max-w-lg mx-auto px-4 pt-5 pb-24" data-testid="driver-account">
        {mfaRequired && (
          <div
            className="mb-5 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2"
            data-testid="driver-account-mfa-banner"
          >
            Finish MFA setup to continue. Your agency requires it for your role.
          </div>
        )}

        <div
          className={`bg-white border rounded-md p-5 mb-5 ${mfaRequired ? "border-amber-300" : "border-slate-200"}`}
          data-testid="driver-account-mfa-section"
        >
          <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 mb-3">Two-step sign-in (MFA)</div>
          <MfaSettings compact />
        </div>

        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 mb-3">Change password</div>
          <p className="text-sm text-slate-600 mb-4">Changing your password signs you out on any other phone or browser.</p>
          <ChangePasswordForm compact />
        </div>
      </div>
    </div>
  );
}
